import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {PromotionBox} from "../../components/PromotionBox";

export const PromotionListListSection = () => {
    const promotions = useSelector((state: IRPStore) => state.promotionList.promotions);

    return (
        <div className={promotionBoxWrapper}>
            {!isEmpty(promotions) ? (
                promotions.map((promotion) => {
                    return (
                        <div key={promotion.id} className={promotionBoxWrapperStyle}>
                            <PromotionBox promotion={promotion} />
                        </div>
                    );
                })
            ) : (
                <Text as="div" className={css({p: 2, textAlign: "center"})}>
                    <div className={css({mb: 1})}>Nie znaleziono promocji o określonych kryteriach.</div>
                    <div>Rozszerz lub zmień parametry szukania i spróbuj ponownie.</div>
                </Text>
            )}
        </div>
    );
};

const promotionBoxWrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const promotionBoxWrapperStyle = css({
    width: "100%",
    maxWidth: "360px",
    alignSelf: "center",

    md: {
        maxWidth: "100%"
    }
});
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {PromotionBox} from "../../components/PromotionBox";

export const PromotionListListSection = () => {
    const promotions = useSelector((state: IRPStore) => state.promotionList.promotions);

    return (
        <div className={promotionBoxWrapper}>
            {!isEmpty(promotions) ? (
                promotions.map((promotion) => {
                    return (
                        <div key={promotion.id} className={promotionBoxWrapperStyle}>
                            <PromotionBox promotion={promotion} />
                        </div>
                    );
                })
            ) : (
                <Text as="div" className={css({p: 2, textAlign: "center"})}>
                    <div className={css({mb: 1})}>Nie znaleziono promocji o określonych kryteriach.</div>
                    <div>Rozszerz lub zmień parametry szukania i spróbuj ponownie.</div>
                </Text>
            )}
        </div>
    );
};

const promotionBoxWrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const promotionBoxWrapperStyle = css({
    width: "100%",
    maxWidth: "360px",
    alignSelf: "center",

    md: {
        maxWidth: "100%"
    }
});
